module.exports = __webpack_public_path__ + "img/px_down.85c81796.svg";